import { Gondor } from "../Gondor";

const ACTIONS = {
  VEHICLE_PURPOSE: "/vehiclePurpose/",
  VEHICLE_PURPOSE_ITEM: "/vehiclePurpose/{id}/",
  ADD_SYSTEMS: "/vehiclePurpose/add/system",
  REMOVE_SYSTEMS: "/vehiclePurpose/remove/system",
};

export function find(params?: object) {
  return Gondor.API.get(ACTIONS.VEHICLE_PURPOSE, { params });
}

export function findOne(id: number | string) {
  id = id.toString();
  return Gondor.API.get(ACTIONS.VEHICLE_PURPOSE_ITEM.replace("{id}", id));
}

export function create(body: object) {
  return Gondor.API.post(ACTIONS.VEHICLE_PURPOSE, body);
}

export function update(id: number | string, body: object) {
  id = id.toString();
  return Gondor.API.patch(
    ACTIONS.VEHICLE_PURPOSE_ITEM.replace("{id}", id),
    body
  );
}

export function destroy(id: number | string) {
  id = id.toString();
  return Gondor.API.delete(ACTIONS.VEHICLE_PURPOSE_ITEM.replace("{id}", id));
}

export function addSystems(body: object) {
  return Gondor.API.post(ACTIONS.ADD_SYSTEMS, body);
}

export function removeSystems(body: object) {
  return Gondor.API.post(ACTIONS.REMOVE_SYSTEMS, body);
}
